export const FUNDING_SOURCE_LABELS: Record<string, string> = {
  EM: 'Employer Match',
  PS: 'Profit Sharing',
  QC: 'QNEC',
  QM: 'QMAC',
  QSHM: 'QSHM',
  QSHNE: 'QSHNE',
  SH: 'Safe Harbor Match',
  SHM: 'Safe Harbor Match',
  SHNE: 'Safe Harbor Nonelective'
};

export const CUSTOM_ACTIVITIES_ORDER = [
  'My Contributions',
  'Employer Contributions',
  'Rollovers In',
  'Dividends',
  'Miscellaneous',
  'Loan Repayments',
  'Loan Disbursements',
  'Withdrawals',
  'Corrective Withdrawals',
  'Conversions',
  'Fees',
  'Gain / Loss'
];
